import _setTimeout from "@babel/runtime-corejs3/core-js/set-timeout";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _Object$assign from "@babel/runtime-corejs3/core-js/object/assign";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import Event from '../helper/event';
import { electronResCodeMap } from '../helper/codeMap';
import { log, bpitLog } from '../../utils';
function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge);
  }
  if (window.WKWebViewJavascriptBridge) {
    return callback(WKWebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];
  var WVJBIframe = document.createElement('iframe');
  WVJBIframe.style.display = 'none';
  WVJBIframe.src = 'https://__bridge_loaded__';
  document.documentElement.appendChild(WVJBIframe);
  _setTimeout(function () {
    document.documentElement.removeChild(WVJBIframe);
  }, 0);
}
var mobileBridgeInit = function mobileBridgeInit() {
  return new _Promise(function (resolve, reject) {
    setupWebViewJavascriptBridge(function (bridge) {
      log("\u6CE8\u518Cresume\u4E8B\u4EF6 ");
      bridge.registerHandler('resume', function (resData) {
        log("resume\u76D1\u542C\u5230\u56DE\u8C03\uFF0C\u76F8\u5173\u53C2\u6570 ", {
          resData: resData
        });
        Event.execEvent('resume', resData);
      });
      log("\u6CE8\u518CunreadMsgAction\u4E8B\u4EF6 ");
      bridge.registerHandler('unreadMsgAction', function (resData) {
        log("unreadMsgAction\u76D1\u542C\u5230\u56DE\u8C03\uFF0C\u76F8\u5173\u53C2\u6570 ", {
          resData: resData
        });
        Event.execEvent('unreadMsgAction', resData);
      });
      log("\u6CE8\u518CwebViewMsgReceive\u4E8B\u4EF6 ");
      bridge.registerHandler('webViewMsgReceive', function (resData) {
        log("webViewMsgReceive\u76D1\u542C\u5230\u56DE\u8C03\uFF0C\u76F8\u5173\u53C2\u6570 ", {
          resData: resData
        });
        Event.execEvent('webViewMsgReceive', resData);
      });
      bridge.registerHandler('pushWorkMsg', function (resData) {
        log("pushWorkMsg\u76D1\u542C\u5230\u56DE\u8C03\uFF0C\u76F8\u5173\u53C2\u6570 ", {
          resData: resData
        });
        Event.execEvent('pushWorkMsg', resData);
      });
      bridge.registerHandler('getTogetherCallback', function (resData) {
        log("getTogetherCallback\u76D1\u542C\u5230\u56DE\u8C03\uFF0C\u76F8\u5173\u53C2\u6570 ", {
          resData: resData
        });
        Event.execEvent('getTogetherCallback', resData);
      });
      bridge.registerHandler('sendMsgCommon', function (resData) {
        log("sendMsgCommon ", {
          resData: resData
        });
        Event.execEvent('sendMsgCommon', resData);
      });
      resolve();
    });
  });
};
var mobileBridge = function mobileBridge(method, param) {
  return new _Promise(function (resolve, reject) {
    var p = _Object$assign({}, param);
    setupWebViewJavascriptBridge(function (bridge) {
      if (param.control) {
        bridge.registerHandler(method, function (data) {
          var onSuccess = param.onSuccess;
          delete p.onSuccess;
          if ('function' === typeof onSuccess) {
            onSuccess(data);
            resolve({
              code: '0',
              message: 'success'
            });
          }
        });
      }
      bridge.callHandler(method, param, function (e) {
        var code = e.code,
          message = e.message,
          data = e.data;
        var _code = _parseInt(code);
        var callbackStr = electronResCodeMap(_code);
        var callbackFun = p[callbackStr];
        log("SDK\u6267\u884C\u540E\u56DE\u8C03\uFF0C\u76F8\u5173\u53C2\u6570 ", {
          method: method,
          param: param,
          data: data,
          _code: _code,
          message: message,
          callbackFun: callbackFun
        });
        // 请求失败
        if (callbackStr === 'onFail') {
          bpitLog({
            method: method,
            errorcode: _code,
            message: message || _JSON$stringify(data) || 'SDK执行失败回调，相关参数'
          });
          if ('function' === typeof callbackFun) {
            message ? callbackFun({
              code: code,
              message: message
            }) : callbackFun(data);
          }
          reject({
            _code: _code,
            message: message,
            data: data
          });
          return;
        }
        // 请求成功
        if ('function' === typeof callbackFun) {
          callbackFun(data || message);
        }
        resolve({
          _code: _code,
          message: message,
          data: data
        });
        // if (_code === -2 || _code === 7) {
        //   bpitLog({
        //     method,
        //     errorcode: _code,
        //     message: message || 'SDK执行失败回调，相关参数',
        //   });
        //   log(`SDK执行后回调，相关参数 `, {
        //     method,
        //     param,
        //     data,
        //     _code,
        //     message,
        //   });
        //   reject({_code, message});
        //   // return;
        // }
        // const callbackFun = p[callbackStr];
        // log(`SDK执行后回调，相关参数 `, {
        //   method,
        //   param,
        //   data,
        //   _code,
        //   message,
        //   callbackFun,
        // });
        // if ('function' === typeof callbackFun) {
        //   callbackFun(data || message);
        // }
        // resolve({_code, message, data});
      });
    });
  });
};

export { mobileBridge, mobileBridgeInit };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/lib/bridge/mobile.js
// module id = null
// module chunks = 